import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "43",
  height: "43",
  viewBox: "0 0 51.498 51.498",
  fill: "#fff"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<defs></defs><g id=\"Group_4238\" data-name=\"Group 4238\" transform=\"translate(-4687.508 7466)\"><path id=\"Path_8041\" data-name=\"Path 8041\" class=\"cls-1\" d=\"M.5 9.211h3.489V.5H.5Z\" transform=\"translate(4713.558 -7466.5)\"></path><path id=\"Path_8042\" data-name=\"Path 8042\" class=\"cls-1\" d=\"M5.751 11.482h8.711V8H5.751Z\" transform=\"translate(4720.505 -7456.576)\"></path><path id=\"Path_8043\" data-name=\"Path 8043\" class=\"cls-1\" d=\"M13.154 4.683 10.69 2.219 3.722 9.187l2.464 2.464Z\" transform=\"translate(4717.819 -7464.225)\"></path><path id=\"Path_8044\" data-name=\"Path 8044\" d=\"m4692.138-7456.837-11.688 33.527-6.833-15.253-14.109-7.043Zm-12.065 24.738 6.793-19.488-18.979 6.532 8.22 4.1Z\" transform=\"translate(28 5.632)\" style=\"fill:#fff;\"></path></g>", 2)
const _hoisted_4 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render };